import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * "Verified live menu" trust badge.
 * Auto-set when a dispensary's integration.sync_enabled=true and last_synced_at < 30 min.
 *
 * Two-line consumer trust signal: stock you see is stock that's there.
 * Quiet incentive for dispensaries to keep their Dutchie integration active.
 */
export const LiveMenuBadge = ({ size = "sm", tone = "default", className = "" }) => {
  const sizes = {
    xs: "text-[9px] gap-1 px-1.5 py-0.5 [&_svg]:w-2.5 [&_svg]:h-2.5",
    sm: "text-[10px] gap-1 px-2 py-1 [&_svg]:w-3 [&_svg]:h-3",
    md: "text-xs gap-1.5 px-2.5 py-1.5 [&_svg]:w-3.5 [&_svg]:h-3.5",
  };
  const tones = {
    default:
      "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
    light: "bg-emerald-500/20 text-emerald-200 border-emerald-400/40",
  };
  return (
    <span
      data-testid="live-menu-badge"
      title="Stock you see is stock that's there. Synced live from the dispensary's POS within the last 30 minutes."
      className={`inline-flex items-center uppercase tracking-[0.18em] font-semibold rounded-full border ${sizes[size]} ${tones[tone]} ${className}`}
    >
      <ShieldCheck strokeWidth={2.2} />
      <span>Live menu</span>
      <span
        className="ml-0.5 w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"
        aria-hidden
      />
    </span>
  );
};
